const gigProposalPayouts = [
	{
		path: '/jobs/gig-proposal-payouts/list',
		name: 'jobs-gig-proposal-payouts-list',
		component: () => import('@/views/jobs/gig-proposal-payouts/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigProposalPayouts
